<div class="documents">
  @if (supportDocuments().length) {
    <section class="pit-card">
      <div class="pit-card__head">
        <h3 class="pit-title">Documentos de suporte</h3>
        <span class="pit-strong"
          >{{ received().received }} de {{ received().total }} recebidos</span
        >
      </div>
      <ul class="documents__list">
        @for (doc of supportDocuments(); track doc.label) {
          <li>
            @switch (doc.status) {
              @case ('recebido') {
                <i class="pi pi-check-circle documents__ok" aria-label="Recebido"></i>
              }
              @case ('parcial') {
                <i class="pi pi-clock documents__wait" aria-label="Recebido em parte"></i>
              }
              @default {
                <i class="pi pi-clock documents__wait" aria-label="Pendente"></i>
              }
            }
            <span>{{ doc.label }}</span>
          </li>
        }
      </ul>
      <p class="pit-caption">{{ note }}</p>
    </section>
  }

  <app-pit-data-room-documents
    [canOpenFolder]="canOpenDataRoom()"
    [folderLabel]="folderLink()?.irpfLinkLabel ?? 'Abrir a pasta IRPF'"
    (openFolder)="openFolder()" />
</div>
